/**
 * 规则指纹
 * 规则最高优先级, 权重区间100000 - 90001, 步长100
 */
import * as Mathchers from './recentCode-mathchers'
import * as IssueRules from './highLight-Mapping'

// 时时彩部分
export const sscAlias =  [
  'cqssc',
  'hn1fc',
  'hn5fc',
  'xjssc',
  'tjssc',
  'jnd30m',
  'rd1fc',
  'rd2fc',
  'txffc',
  'qqffc',
  'rbffc',
  'xgffc',
  'ynffc',
  'cq30s',
  'tx30s',
  'mmc',
  'txdsq',
  'txssq',
  'txwfc',
  'sytxffc',
  'xgwfc',
  'ynwfc',
	'qq1fc',
	"tg300s",
	"tg60s",
	"syqiqu",
	"btcffc",
	"zfbffc",
	"zfb5fc"
];

// 11选5部分
export const _11x5Alias = ['gd11x5', 'jx11x5', 'sd11x5', 'sh11x5', 'ah11x5','jnd11x5', "hlj11x5", "hb11x5", "ln11x5", "tg11x5ff", "yn11x5", "tg11x5", "gx11x5"];
// 3D 排列3
export const _3dAlias = ['3dfc','pl3','3djnd'];
// PK10
export const pk10Alias = ['pk10', 'ydl10', 'xyft', "jssc", "ynpk10ff", "ynpk10wf"];
// jssm
export const jssmAlias = ['jssm'];
// 快3
export const k3Alias = ['jsk3', 'ahk3', 'gxk3', 'hbk3', "hnks",  "jlks"];

export default function Mathcher(R){

	return [
		// 匹配
		{
			priority: 100000,
			condition: function(R) {
		    R.when( !this.ruleSuite );
		  },
		  consequence: function(R) {
		  	const methodName = _.trim(this.currentMethod.categoryName + this.currentMethod.methodName);
		  	const alias = this.currentMethod.flag;
		  	this.ruleSuite = Mathchers.method2RuleSuite(methodName, alias)
		    R.next();
		  }
		},
		// 期号截取
		{
			priority: 99900,
			condition: function(R) {
		    R.when( this.currentMethod.flag != 'mmc' );
		  },
		  consequence: function(R) {
		  	const alias = this.currentMethod.flag;
		  	// 时时彩类型的，截取前4
		  	_.each(this.historyCodes, function(history){
		  		if (_.includes(_.concat(sscAlias, ['3djnd', 'ydl10', 'jssm', 'xyft']), alias)) {
		  			history.issue = history.issue && history.issue.slice(4);
		  		}
		  	})
		  	// 期号高亮
		  	this.historyCodes = IssueRules.remarkIssue(alias, this.historyCodes);
		    R.next();
		  }
		},
		{
			priority: 99850,
			condition: function(R) {
		    R.when( this.currentMethod.flag == 'mmc' );
		  },
		  consequence: function(R) {
		  	const alias = this.currentMethod.flag;
		  	// 秒秒彩填充期号
		  	_.each(this.historyCodes, function(history){
	  			history.issue = '------';
	  			history.issueClass = 'mmc'
		  	})
		    R.next();
		  }
		},
		{
			priority: 99840,
			condition: function(R) {
		    R.when( _.includes(_.concat(pk10Alias, jssmAlias), this.currentMethod.flag) );
		  },
		  consequence: function(R) {
		  	const alias = this.currentMethod.flag;
		  	_.each(this.historyCodes, function(history){
	  			history.issueClass = 'pk10'
		  	})
		    R.next();
		  }
		},
		// 无匹配直接返回
		{
			priority: 99800,
			condition: function(R) {
		    R.when( !this.ruleSuite );
		  },
		  consequence: function(R) {
		  	const history = _.map(this.historyCodes, (item) => ({
		  			issue: item.issue,
		  			codes: item.split_code.map((item) => ({codes: item, className: 'active'})),
		  			draw_time: item.draw_time,
		  			issueClass: item.issueClass || ''
		  	}))
				this.done = {
					history,
					currentMethod: this.currentMethod
				}
		    R.stop();
		  }
		},
		// 获取算法有用的值
		{
			priority: 99700,
			condition: function(R) {
		    R.when( true );
		  },
		  consequence: function(R) {
		  	_.each(this.historyCodes, function(history){
		  		// 对算法产生影响的号码
		  		let workCode = [];
		  		let displayCode = [];
		  		const positions = _.split(this.ruleSuite.position, ',');
		  		_.each(positions, function(item, index){
		  			if (item === 'X') {
		  				workCode.push(parseInt(history.split_code[index]));
		  				displayCode.push({codes: history.split_code[index], className: 'active'})
		  			}else{
		  				displayCode.push({codes: history.split_code[index], className: 'disabled'})
		  			}
		  		})
		  		history.workCode = workCode;
		  		history.displayCode = displayCode;
		  		history.form = [];
		  	}.bind(this))
		    R.next();
		  }
		}
	]
}